export default __webpack_public_path__ + "static/media/p7.3374c0c8.png";